<section
  class="ui-inline-message"
  role="note"
  [class.ui-inline-message-neutral]="isNeutral()"
  [class.ui-inline-message-info]="isInfo()"
  [class.ui-inline-message-success]="isSuccess()"
  [class.ui-inline-message-warning]="isWarning()"
  [class.ui-inline-message-danger]="isDanger()"
  [attr.aria-live]="ariaLive()"
>
  <span class="ui-inline-message-icon" aria-hidden="true">{{
    iconLabel()
  }}</span>
  <span class="ui-inline-message-text">{{ text() }}</span>
</section>
